<template>
    <CompassModal
        v-model:visible="visible"
        :title="$t.__('ocr.OcrAmountDifferenceModal.title')"
        :size="CompassEnums.ModalSize.SMALL"
        :primaryAction="{
            label: $t.__('common.actions.validate'),
            type: CompassEnums.ButtonType.PRIMARY,
            action: confirm,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                type: CompassEnums.ButtonType.SECONDARY,
                action: cancel,
            },
        ]"
        @closed="cancel"
    >
        <!-- eslint-disable vue/no-v-html -->
        <p
            class="amount-difference-modal__description typographies-paragraph-medium-regular"
            v-html="alertDescription"
        />
        <!-- eslint-enable vue/no-v-html -->
        <CompassCallout
            class="amount-difference-modal__what-to-do"
            :title="$t.__('ocr.OcrAmountDifferenceModal.what_to_do')"
            icon="success-circle-fill"
            :items="whatToDoItems"
        />
        <p class="amount-difference-modal__question typographies-paragraph-medium-regular">
            {{ $t.__('ocr.OcrAmountDifferenceModal.confirm_question') }}
        </p>
    </CompassModal>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';

import { Translator } from 'types/injects/translator.type';

interface Props {
    lineTotal: string;
    ocrTotal: string;
    isTaxMode?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    isTaxMode: false,
});

const visible = defineModel<boolean>('visible', { default: false });

const emit = defineEmits<{
    confirm: [];
    cancel: [];
}>();

const $t = inject('$t') as Translator;

const alertDescription = computed<string>(() =>
    $t.__('ocr.OcrAmountDifferenceModal.alert', {
        lineTotal: props.lineTotal,
        ocrTotal: props.ocrTotal,
    }),
);

const whatToDoItems = computed<string[]>(() => {
    const items = [$t.__('ocr.OcrAmountDifferenceModal.option_edit_lines')];
    if (!props.isTaxMode) {
        items.push($t.__('ocr.OcrAmountDifferenceModal.option_switch_tax'));
    }
    return items;
});

const confirm = (): void => emit('confirm');
const cancel = (): void => emit('cancel');
</script>

<style lang="scss" scoped>
.amount-difference-modal {
    &__description {
        margin: 0 0 var(--spacing-2) 0;
    }

    &__what-to-do {
        margin: var(--spacing-2) 0;
    }

    &__question {
        margin: 0;
    }
}
</style>
